// extracted by mini-css-extract-plugin
module.exports = {"container":"_9330de7794--container--haw3a","tabs":"_9330de7794--tabs--Q6nMx","title":"_9330de7794--title--F1xXM"};